var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    fill: "none",
    viewBox: "0 0 20 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B8085",
    d: "M10.6247 5.3952a.618.618 0 0 1-.625-.6116c0-2.3667 1.96-4.2833 4.3733-4.2833a.6164.6164 0 0 1 .625.6117c0 2.3666-1.9583 4.2832-4.3733 4.2832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B8085",
    d: "M10.6249 5.3952a.619.619 0 0 1-.5754-.3755.62.62 0 0 1-.0496-.2361c0-2.3667 1.9599-4.2833 4.3733-4.2833a.616.616 0 0 1 .5758.3753.62.62 0 0 1 .0491.2364c0 2.3666-1.9583 4.2832-4.3732 4.2832m9.1249 12.8849c.2416.1766.3199.5.1833.7633-2.2 4.3099-3.955 6.4566-5.5583 6.4566-.7466 0-1.48-.2367-2.195-.6967a3.308 3.308 0 0 0-3.455-.0733c-.8666.5083-1.6916.77-2.4749.77C3.8916 25.5 0 18.3884 0 14.4868c0-4.1666 2.2316-7.3433 5.625-7.3433 1.5966 0 2.9749.23 4.1332.6984.49.1966 1.045.1833 1.5233-.0417.94-.4433 2.18-.6566 3.7166-.6566 1.8784 0 3.5167.9166 4.8767 2.6916a.61.61 0 0 1 .1054.2153.603.603 0 0 1-.2304.6413c-1.5184 1.1167-2.25 2.3683-2.25 3.795 0 1.425.7316 2.6783 2.25 3.7933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B8085",
    d: "M19.7498 18.2801c.2416.1766.3199.5.1833.7633-2.2 4.31-3.955 6.4566-5.5583 6.4566-.7466 0-1.48-.2367-2.195-.6967a3.308 3.308 0 0 0-3.455-.0733c-.8666.5083-1.6916.77-2.4749.77C3.8916 25.5 0 18.3884 0 14.4868c0-4.1666 2.2316-7.3433 5.625-7.3433 1.5966 0 2.9749.23 4.1332.6984.49.1966 1.045.1833 1.5233-.0417.94-.4433 2.18-.6566 3.7166-.6566 1.8784 0 3.5167.9166 4.8767 2.6916a.61.61 0 0 1 .1054.2153.603.603 0 0 1-.2304.6413c-1.5184 1.1167-2.25 2.3683-2.25 3.795 0 1.425.7316 2.6783 2.25 3.7933"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple-icon.673ecbafaa22601c5bad2c609e683736.svg";